import { notDesktop, styled, Text, useTranslation } from '@obvio/app'
import { Grid, GridItem, Stack } from '@obvio/ui'

import { CenteredSection } from '../CenteredSection'
import { useCursorContext } from '../Cursor'

import type { ReactElement } from 'react'

const Title = styled(Text)`
  font-size: 9.375rem;
  line-height: 120%;
  font-weight: 300;

  @media ${notDesktop} {
    font-size: 4rem;
  }
`

const Actions = styled(Grid)`
  width: 100%;
  @media ${notDesktop} {
    grid-template-columns: auto;
    grid-auto-rows: 11.37rem;
    grid-template-rows: unset;
  }
`

const TextWrap = styled.div`
  height: 100%;
  width: 100%;
  ${(theme) => theme.flexCenter}
`

const ActionText = styled(Text)`
  font-size: 2.25rem;
  line-height: 120%;
  font-weight: 300;
`

const Item = styled(GridItem)`
  width: 100%;
  height: 100%;
  border: 0.75px solid white;
`

const Section = styled(CenteredSection)`
  padding-top: 0 !important;
`

type EventRespondSectionProps = {
  setRegister(): void
  setDecline(): void
}

export function EventRespondSection({
  setRegister,
  setDecline,
}: EventRespondSectionProps): ReactElement {
  const { t } = useTranslation()
  const { setValue } = useCursorContext()
  return (
    <Section id="rsvp">
      <Stack kind="vertical" spacing="extraLarge" fullWidth>
        <Title tag="h2">Répondez</Title>
        <Actions templateColumns="1fr 1fr" templateRows="20.25rem" gap="medium">
          <Item>
            <TextWrap
              onMouseLeave={() => setValue(null)}
              onMouseEnter={() => setValue('DECLINE')}
              onClick={setDecline}
              role="presentation"
            >
              <ActionText tag="h3">{t('event.decline')}</ActionText>
            </TextWrap>
          </Item>
          <Item>
            <TextWrap
              onMouseLeave={() => setValue(null)}
              onMouseEnter={() => setValue('JOIN')}
              onClick={setRegister}
              role="presentation"
            >
              <ActionText tag="h3">{t('event.approve')}</ActionText>
            </TextWrap>
          </Item>
        </Actions>
      </Stack>
    </Section>
  )
}
